// exchange.slice.js
import { createSlice } from '@reduxjs/toolkit';

const exchangeSlice = createSlice({
  name: 'exchange',
  initialState: {
    loading: false,
    error: null,
    exchangeType: 'user',
    selectedCompanyPortfolioIds: [],
    selectedUserPortfolioIds: []
  },
  reducers: {
    setExchangeType: (state, action) => {
      state.exchangeType = action.payload;
    },

    addExchangePortfolioId: (state, action) => {
      const portfolioId = action.payload;
      if (state.exchangeType === 'user') {
        if (!state.selectedUserPortfolioIds.includes(portfolioId)) {
          state.selectedUserPortfolioIds.push(portfolioId);
        }
      } else if (state.exchangeType === 'company') {
        if (!state.selectedCompanyPortfolioIds.includes(portfolioId)) {
          state.selectedCompanyPortfolioIds.push(portfolioId);
        }
      }
    },

    removeExchangePortfolioId: (state, action) => {
      const portfolioId = action.payload;
      if (state.exchangeType === 'user') {
        state.selectedUserPortfolioIds = state.selectedUserPortfolioIds.filter(
          id => id !== portfolioId
        );
      } else if (state.exchangeType === 'company') {
        state.selectedCompanyPortfolioIds = state.selectedCompanyPortfolioIds.filter(
          id => id !== portfolioId
        );
      }
    },

    clearExchangePortfolioId: (state) => {
      if (state.exchangeType === 'user') {
        state.selectedUserPortfolioIds = [];
      } else if (state.exchangeType === 'company') {
        state.selectedCompanyPortfolioIds = [];
      }
    }
  }});

// Updated selectors to use contentGroups state
export const selectExchanges = (state) =>
  state.contentGroups.groups['portfolioExchanges'] || [];

export const selectExchangeLoading = (state) =>
  state.contentGroups.status['portfolioExchanges'] === 'loading';

export const selectExchangeError = (state) =>
  state.contentGroups.error['portfolioExchanges'];

export const selectExchangePortfolios = (state, exchangeId) => {
  const exchanges = selectExchanges(state);
  const exchange = exchanges?.find(e => e.fields.name === exchangeId);
  const portfolioIds = exchange?.fields?.portfolioIds || [];

  return (state.portfolios?.items || []).filter(portfolio =>
    portfolioIds.includes(portfolio.id)
  );
};

export default exchangeSlice.reducer;

export const {
    setExchangeType,
    addExchangePortfolioId,
    removeExchangePortfolioId,
    clearExchangePortfolioId
} = exchangeSlice.actions;
